import { ConcreteEncodable } from "./ConcreteEncodable";

import { MarketTimeConstantImplEncoder } from "../../encoder/MarketTimeConstantImplEncoder";

import * as CubiqTS from "../../index";
import { MarketTimeConstant } from "../MarketTimeConstant";

export class MarketTimeConstantImpl extends ConcreteEncodable implements MarketTimeConstant {
  public static enType: string = "com.bcdfx.model.MarketTimeConstantImpl";

  /*FID=1*/
  public id: CubiqTS.Long | null = null;
  /*FID=2*/
  public constantName: string;
  /*FID=3*/
  public constantType: CubiqTS.MarketTimeConstantType;
  /*FID=4*/
  public constantDate: CubiqTS.moment.Moment | null = null;
  /*FID=5*/
  public constantTime: CubiqTS.Long | null = null;
  /*FID=6*/
  public timeZoneCd: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = MarketTimeConstantImplEncoder.Instance;
    this.setEncodableType(MarketTimeConstantImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "MarketTimeConstantImpl[" +
      "id=" +
      this.id +
      "constantName=" +
      this.constantName +
      "constantType=" +
      this.constantType +
      "constantDate=" +
      this.constantDate +
      "constantTime=" +
      this.constantTime +
      "timeZoneCd=" +
      this.timeZoneCd +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
